import React, { useState } from 'react';
import '../asset/css/Form.css';
import { useNavigate } from 'react-router-dom';

export default function Form() {
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        emailAddress: '',
        address: '',
        city: '',
        country: '',
        role: '',
        age: '',
        interesting: '',
        comskill: '',
        gender: '',
        expectations: '',
        submission: '',
        course: ''
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setloading(true);
        fetch('https://mmao.vercel.app/submit/course/form', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(r => r.json()).then((rs) => {
            if (rs.status === 'success' && rs.data) {
                setloading(false);
                window.alert(rs.text);
                navigate('../')
            } else {
                setloading(false);
                window.alert(rs.text);
            }
        })
    };
    return (
        <div className="form-page-container">
            <div className="form-card">
                {/* Header Section */}
                <div className="form-header">
                    <div className="brand-logo-area">
                        <div className="hex-logo">
                            <svg width="40" height="40" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M50 5L88.9711 27.5V72.5L50 95L11.0289 72.5V27.5L50 5Z" stroke="#4A3FCD" strokeWidth="6" fill="#F4F3FF" />
                                <path d="M50 25L71.6506 37.5V62.5L50 75L28.3494 62.5V37.5L50 25Z" fill="#4A3FCD" fillOpacity="0.2" />
                            </svg>
                        </div>
                        <div className="brand-text">
                            <span className="brand-name">MMao</span>
                            <span className="brand-sub">Learning</span>
                        </div>
                    </div>
                    <div className="header-titles">
                        <h1 className="main-title">Student Course Form</h1>
                        <p className="subtitle">This form is only for enrolled student. The form from unenrolled user will be rejected.</p>
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* Section 1: Personal Info */}
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor='firstname'>First Name</label>
                            <input
                                id='firstname'
                                type="text"
                                name="firstName"
                                className='finp'
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='lastname'>Last Name</label>
                            <input
                                id='lastname'
                                type="text"
                                name="lastName"
                                className='finp'
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='email'>Email Address</label>
                            <input
                                id='email'
                                type="email"
                                name="emailAddress"
                                className='finp'
                                value={formData.emailAddress}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Section 2: Content Details */}
                    <div className="section-banner">Personal Informations</div>
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor='gender'>Gender</label>
                            <select
                                id='gender'
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className="form-select finp"
                                required
                            >
                                <option value="">Select your gender...</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="None">None</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor='address'>Home Address</label>
                            <input
                                id='address'
                                type="text"
                                name="address"
                                className='finp'
                                value={formData.address}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='city'>City</label>
                            <input
                                id='city'
                                type="text"
                                name="city"
                                className='finp'
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='country'>Country</label>
                            <input
                                id='country'
                                type="text"
                                name="country"
                                className='finp'
                                value={formData.country}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Section 3: SEO Requirements */}
                    <div className="section-banner">Biography Informations</div>
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor='role'>Your current position(Eg. student,teacher,..)</label>
                            <input
                                id='role'
                                type="text"
                                name="role"
                                className='finp'
                                value={formData.role}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='age'>Current age</label>
                            <input
                                id='age'
                                type="text"
                                name="age"
                                className='finp'
                                value={formData.age}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='interesting'>Your interesting</label>
                            <input
                                id='interesting'
                                type="text"
                                className='finp'
                                name="interesting"
                                value={formData.interesting}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor='comskill'>Computer skill</label>
                            <input
                                id='comskill'
                                type="text"
                                className='finp'
                                name="comskill"
                                value={formData.comskill}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group full-width">
                            <label htmlFor='expectations'>Expectations from the course</label>
                            <input
                                id='expectations'
                                type="text"
                                className='finp'
                                name="expectations"
                                value={formData.expectations}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Section 4: Deadline & Priority */}
                    <div className="section-banner">Enrolled course</div>
                    <div className="form-grid deadline-priority-section">
                        <div className="form-group">
                            <label htmlFor='course'>Course</label>
                            <select
                                id='course'
                                name="course"
                                value={formData.course}
                                onChange={handleChange}
                                required
                                className="form-select finp"
                            >
                                <option value="">Select your course...</option>
                                <option value="Web development 1 (Online)">Web development 1 (Online)</option>
                                <option value="Web development 1 (Offline)">Web development 1 (Offline)</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor='date'>Enrolled date</label>
                            <input
                                id='date'
                                type="date"
                                className='finp'
                                name="submission"
                                placeholder="mm/dd/yyyy"
                                value={formData.submission}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="form-actions">
                        <button type="submit" className="submit-btn">
                            {loading && <div className='whiteloading' style={{ marginRight: 9 }}></div>}
                            Submit Request
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}